module.exports = __webpack_public_path__ + "static/media/q4-care-logo.2529b8a7.jpg";